import React, { Component } from 'react';
import classNames from 'classnames';
import 'styles/About.css';
var ga = window.ga;

class AboutPageTwo extends Component {
	constructor(props) {
		super(props);

	}

  componentDidMount() {
    ga('send', 'event', 'About 2 Page', 'Page View');
  }


  handlePrev = () => {
    // window.dispatchEvent(this.props.events.animPage1, false);
    this.props.hideReact(1);
  }

  handleNext = () => {
    // window.dispatchEvent(this.props.events.animPage3, false);
    this.props.hideReact(3);
  }


  render() {
    return (
      <div id="AboutPageTwo" className="about-page" ref={(el) => this.el = el} >
        <h1 className="stagger-in">Raise your standards for creative digital production.</h1>
        <div className="red-line stagger-in"/>
        <p className="stagger-in">Experience a truly streamlined process, where tight timelines and budgets don't get in the way of producing award-winning digital.</p>
        <div className="arrow-container stagger-in">
          <div className="arrow left" onClick={this.handlePrev}/>
          <div className="arrow right" onClick={this.handleNext}/>
        </div>
      </div>
    );
  }
}

export default AboutPageTwo;


// WEBPACK FOOTER //
// ./src/scripts/containers/AboutPageTwo.js